import React from 'react';
import './StickyContent.scss';

class StickyContent extends React.Component {
  componentDidUpdate(prevProps) {
    const { handleModifierChange, modifiers } = prevProps;
    if (handleModifierChange && this.props.modifiers[0] !== modifiers[0]) {
      this.props.handleModifierChange(modifiers[0]);
    }
  }

  render() {
    const { className, children, modifiers } = this.props;

    const modifierClasses = modifiers.length ? modifiers.reduce((result, modifier) => {
      result = `${result} ${StickyContent.baseClass}_${modifier} ${className}`; // eslint-disable-line no-param-reassign
      return result;
    }, '') : '';

    return (
      <div className={`${StickyContent.baseClass} ${modifierClasses}`}>
        {children}
      </div>
    );
  }
}

StickyContent.baseClass = 'mn_stickyContent';

export default StickyContent;
